import CreateProfileContentContainer from './CreateProfileContentContainer';

export default CreateProfileContentContainer;



// WEBPACK FOOTER //
// ./src/components/pages/ConfirmationPage/CreateProfile/components/CreateProfileContent/index.js